import { Component, EventEmitter , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { ISecurityGroup } from "../../../interfaces/isecuritygroup";
import { IButton } from "../../../interfaces/ibuttons";
import { EmitterService } from "../../../services/emitter.service";
import { ArrayPropertyFilterPipe } from "../../../pipes/arrayproperty.pipe";

@Component({
    selector: "securitygroups",
    standalone: true,
    imports: [CommonModule, FormsModule, RouterModule, ArrayPropertyFilterPipe],
    templateUrl: "./securitygroups.component.html",
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SecurityGroupsComponent {
    securityGroups: ISecurityGroup[];
    searchTerm: string;
    headerButtons: IButton[];
    constructor(activatedRoute: ActivatedRoute, private router: Router ) {
        this.securityGroups = activatedRoute.snapshot.data["securityGroups"];
    }

    createSecurityGroupClicked(): void {
        this.router.navigate(["/securitygroups/securitygroup"]);
    }

    securityGroupClicked(securityGroup: ISecurityGroup): void {
        this.router.navigate([`/securitygroups/securitygroup/${securityGroup.id}`]);
    }

    onButtonClick(): void {
        this.router.navigate(["/securitygroups/securitygroup"]);
    }
}

